<template>  
 <ContentHeader />
  <div id="content-page" class="content-page">
  <div class="container">
    <div class="row">   
        <SocialPoster :avatar="avatar"/>
        <input type="hidden" name="page_id" id="page_id" value="0"/>

    </div>
    <div class="row">
        <div class="col-lg-12">            
        </div>
    </div>
    <div class="row">           
        <div class="col-lg-12 row m-0 p-0">
            <div class="col-sm-12">         
                <!-- START USER POSTS -->                     
                <div id="all-wall-posts">                        
                    <!-- END USER POSTS -->     
                    <div v-for="post in posts" :key="post.post_id">
                        <Posts :seen_posts="seen_posts" :post_views="post.post_views" :post_comments="post.post_comments" :post_date="post.post_date" :post_user_sub="post.user_sub" :post_text="post.post_text" :post_shares="post.post_shares" :post_link="post.post_link" :post_likes="post.post_likes" :post_page_id="post.post_page_id" :post_image="post.post_image" :post_by_avatar="post.post_by_avatar" :post_by_id="post.post_by_id" :post_by_names="post.post_by_names" :post_id="post.post_id"  :post_type="post.post_type" /> 
                    </div>       
                </div>  
                <input type="hidden" id="active_post" value="0"/>
                <div id="spin_loader"><img src="https://tshaku.com/view/socialV/assets/images/page-img/page-load-loader.gif"/></div>         
                    <router-link :to="'/'" class="btn btn-primary d-block w-100 mt-3">Load More Posts</router-link>
                    <input type="hidden" id="last_loaded_post" value="0"/>
                    <br/>                               
                </div> 
            </div>
            <div class="col-sm-12 text-center">                            
            </div>
        </div>
    </div>
  </div>
  <ContentFooter/>
</template>

<script>
import {computed, reactive, ref} from 'vue'
import router from '@/router'
import axios from 'axios'
import ContentHeader from './includes/ContentHeader.vue'
import ContentFooter from './includes/ContentFooter.vue'
import SocialPoster from './includes/SocialPoster.vue'
import Posts from './includes/Post.vue'
import { useHead } from '@vueuse/head'
export default {
    name: 'Home',
    setup(props){        
        function cat_title(cat_id){
            var cat_title=''
            if(cat_id==1){
                cat_title='Finance';
            }
            else if(cat_id==2){
                cat_title='Technology';
            }
            else if(cat_id==2){
                cat_title='Technology';
            }
            else if(cat_id==3){
                cat_title='Gospel';
            }
            else if(cat_id==4){
                cat_title='Fashion';
            }
            else if(cat_id==5){
                cat_title='Comedy';
            }
            else if(cat_id==6){
                cat_title='Education';
            }
            else if(cat_id==7){
                cat_title='Children';
            }
            else if(cat_id==8){
                cat_title='News';
            }
            else if(cat_id==9){
                cat_title='Agency';
            }
            else if(cat_id==10){
                cat_title='Real Estate';
            }
            else if(cat_id==11){
                cat_title='Television';
            }
            else if(cat_id==12){
                cat_title='Gaming';
            }
            else if(cat_id==13){
                cat_title='Movies';
            }
            else if(cat_id==14){
                cat_title='People';
            }
            else if(cat_id==15){
                cat_title='Autos';
            }            
            else if(cat_id==16){
                cat_title='Cooking';
            }            
            else if(cat_id==17){
                cat_title='Health';
            }
            else if(cat_id==18){
                cat_title='Music';
            }
            else if(cat_id==18){
                cat_title='Sports';
            }                    
            else{
                cat_title='Tshaku'
            }
            return cat_title;
        }
        var cat_id=props.cat_id
        var cat_title=cat_title(cat_id)    
        const siteData = reactive({
        title: 'Tshaku - '+cat_title,
        description : cat_title,
        })
        useHead({
        //Can be static or computed
        title: computed(() => siteData.title),
        meta: [
            {
            name:'description',
            content: computed(() => siteData.description)
            }
        ],      
        })
    }, 
    data(){
        return{
            intervalId: null,
            posts:'',                        
            seen_posts:'',
            posts_loaded:false           
        }        
    },
    computed:{
        
    },
    props:['cat_id'],
    watch: { 
        cat_id: function() { // watch it
            this.load_posts()
            this.scrollToTop()
            var cat_title=this.cat_title(this.cat_id)
            //Cat titles :
            /*var cat_title=cat_title();            
            */
            useHead({ title:"Tshaku - "+cat_title})
            //*/
        }
    },
    components:{SocialPoster,Posts,ContentHeader,ContentFooter},  
    mounted(){
        this.refresh_posts()   
        this.intervalId = setInterval(this.refresh_posts, 60000)
    },
    beforeUnmount() {
        // Clean up
        if (this.intervalId) {
            clearInterval(this.intervalId)
        }
    },
    created(){ 
        this.load_posts()
        //*/
    },     
    methods:{ 
        cat_title(cat_id){
            var cat_title=''
            if(cat_id==1){
                cat_title='Finance';
            }
            else if(cat_id==2){
                cat_title='Technology';
            }
            else if(cat_id==2){
                cat_title='Technology';
            }
            else if(cat_id==3){
                cat_title='Gospel';
            }
            else if(cat_id==4){
                cat_title='Fashion';
            }
            else if(cat_id==5){
                cat_title='Comedy';
            }
            else if(cat_id==6){
                cat_title='Education';
            }
            else if(cat_id==7){
                cat_title='Children';
            }
            else if(cat_id==8){
                cat_title='News';
            }
            else if(cat_id==9){
                cat_title='Agency';
            }
            else if(cat_id==10){
                cat_title='Real Estate';
            }
            else if(cat_id==11){
                cat_title='Television';
            }
            else if(cat_id==12){
                cat_title='Gaming';
            }
            else if(cat_id==13){
                cat_title='Movies';
            }
            else if(cat_id==14){
                cat_title='People';
            }
            else if(cat_id==15){
                cat_title='Autos';
            }            
            else if(cat_id==16){
                cat_title='Cooking';
            }            
            else if(cat_id==17){
                cat_title='Health';
            }
            else if(cat_id==18){
                cat_title='Music';
            }
            else if(cat_id==18){
                cat_title='Sports';
            }                    
            else{
                cat_title='Tshaku'
            }
            return cat_title;
        },         
        scrollToTop(){
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },                      
        check_posts(){        
            $(window).scroll(function() {             
            const posts=JSON.parse(localStorage.getItem('Home_posts'))
            if(posts){                                           
                for (var k in posts){                    
                    var post=posts[k]                                        
                    var the_div='post_is_'+post.post_id                                                            
                    var element = document.getElementById(the_div)
                    if(element){
                        const elementTop = element.offsetTop;             
                        const elementBottom = elementTop + element.offsetHeight; 
                        const viewportTop = window.pageYOffset; 
                        const viewportBottom = viewportTop + window.innerHeight;   
                        if (elementBottom > viewportTop && elementTop < viewportBottom) {
                            //Check if the seen post is already in the array
                            if(!this.seen_posts){
                                //The seen posts variable is empty
                                this.seen_posts+='|'+post.post_id
                            }
                            else{
                                //The seen posts variable is not empty
                                //Check if this post was already added to it
                                var seen_posts=this.seen_posts;
                                var myarr = seen_posts.split('|');
                                if(!myarr.includes(post.post_id)){
                                    //This is not yet recorded
                                    if(post.post_id!='undefined'){
                                        this.seen_posts+='|'+post.post_id                                           
                                        localStorage.setItem('Seen_posts', this.seen_posts);                                        
                                    }                                    
                                }
                            }
                            //console.log(this.seen_posts)
                            
                        } 
                        else {
                            //else what?;
                        }                                   
                    }                    
                }
                //*/
                //Check if any of the loaded posts is in the view port right now
            } 
            //*/           
            });        
        },
        async load_posts(){            
            //*
            //const cachedData = JSON.parse(localStorage.getItem('Home_posts'));
            this.posts='';
            this.$store.dispatch("updateCatId",this.cat_id)
            if(0){
                this.posts=cachedData                
            }
            else{
                const posts = await axios.get('post.php?action=load&cat_id='+this.cat_id,{
                                headers: {
                                    Authorization:localStorage.getItem('token')
                                }
                            })                   
                //localStorage.setItem('Home_posts', JSON.stringify(posts.data));
                this.posts=posts.data    
                this.posts_loaded=true                    
                //Watch for seen posts              
                setTimeout(this.check_posts(),50)
                //End Watch for seen posts
                //console.log(posts.data)
                
            }            
        },
        async refresh_posts(){            
            //* This function helps in refreshing the post
            const posts = await axios.get('post.php?action=load&cat_id='+this.cat_id+'&refresh=true&seen_posts='+this.seen_posts,{
                headers: {
                    Authorization:localStorage.getItem('token')
                }
            })   
        },
        visibilityChanged () {     
            //alert('Post id Is visible')
        }
    }   
}
</script>

<style>
    
</style>